import request from '@/utils/request/index'

export default {
  // 获取所有的实验台菜单
  getLabTypeAllList(params) {
    return request.post('/v1/front/lab/type/getLabTypeAllList', params)
  },
  // 根据ID获取实验台菜单名称
  getLabTypeNameById(params) {
    return request.post('/v1/front/lab/type/getLabTypeNameById', params)
  },
  // 根据实验台ID获取所有连接点信息
  getLabPointAllList(params) {
    return request.post('/v1/front/lab/point/getLabPointAllList', params)
  },
  // 检查连接线信息
  checkConnectorInfo(params) {
    return request.post('/v1/front/lab/connector/checkConnectorInfo', params)
  },
  // 删除连接线信息
  deleteConnectorInfo(params) {
    return request.post('/v1/front/lab/connector/deleteConnectorInfo', params)
  },
  // 检查连接线是否完成
  checkConnectorHasFinish(params) {
    return request.post('/v1/front/lab/connector/checkConnectorHasFinish', params)
  },
  // 根据类型获取实验台整定值信息
  getLabSettingValueListByTypeId(params) {
    return request.post('/v1/front/lab/settingValue/getLabSettingValueListByTypeId', params)
  },
  // 保存整定值
  saveSettingValue(params) {
    return request.post('/v1/front/lab/settingValue/saveSettingValue', params)
  },
  // 获取线路整组相关设置信息
  getCSYLineProtectSettingList(params) {
    return request.post('/v1/front/lab/settingValue/getCSYLineProtectSettingList', params)
  },
  // 获取变压器整组相关设置信息
  getCSYTransfProtectSettingList(params) {
    return request.post('/v1/front/lab/settingValue/getCSYTransfProtectSettingList', params)
  },
  // 同步定值
  syncSettingValue(params) {
    return request.post('/v1/front/lab/settingValue/syncSettingValue', params)
  },

}
